import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loder/loader";
import { getItem, setItem } from "./localStorage";

export const ThemeContext = createContext();

const HEALTHCARE_BRAND_ID = 1;
const PRIMECARE_BRAND_ID = 2;

const getBrandIdFromTheme = (value) =>
  value === "healthCare" ? HEALTHCARE_BRAND_ID : PRIMECARE_BRAND_ID;

const getThemeFromBrandId = (brandId) =>
  Number(brandId) === HEALTHCARE_BRAND_ID ? "healthCare" : "primeCare";

const getInitialBrandState = () => {
  const storedRefBrandId = getItem("refBrandId");
  const storedTheme = getItem("theme");

  if (storedRefBrandId != null) {
    const brandId = Number(storedRefBrandId);
    return {
      theme: storedTheme || getThemeFromBrandId(brandId),
      brandId,
    };
  }

  const theme = storedTheme || "healthCare";
  return {
    theme,
    brandId: getBrandIdFromTheme(theme),
  };
};

export const ThemeProvider = ({ children }) => {
  const initialBrandState = getInitialBrandState();
  const [isLoading, setIsLoading] = useState(false);
  const [theme, setTheme] = useState(initialBrandState.theme);
  const [brandId, setBrandId] = useState(initialBrandState.brandId);
  const navigate = useNavigate();
  const toggleTheme = () => {
    setIsLoading(true);
    navigate("/dashboard");
    setTheme((prevTheme) =>
      prevTheme === "healthCare" ? "primeCare" : "healthCare"
    );
  };

  useEffect(() => {
    const refBrandId = getBrandIdFromTheme(theme);
    setItem("theme", theme);
    setItem("refBrandId", refBrandId);
    setBrandId(refBrandId);
    setIsLoading(false);
  }, [theme]);

  return (
    <>
      {isLoading && <Loader loaderTransform="loaderTransform" />}
      <ThemeContext.Provider value={{ theme, toggleTheme, brandId, isLoading }}>
        {children}
      </ThemeContext.Provider>
    </>
  );
};
